{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "agents",
  "title": "Agents",
  "description": "Agent catalog and per-domain toggles. Global default defines the full agent list; site overrides change enabled state.",
  "type": "object",
  "x-access": "staff",
  "properties": {
    "agents": {
      "type": "object",
      "ui:description": "Map of agent ID to its definition and enabled state",
      "additionalProperties": {
        "type": "object",
        "properties": {
          "description": {
            "type": "string",
            "ui:description": "Short description shown in the backoffice agent card",
            "maxLength": 500
          },
          "name": {
            "type": "string",
            "ui:description": "Display name shown in the backoffice",
            "maxLength": 100,
            "minLength": 1
          },
          "status": {
            "type": "string",
            "enum": [
              "active",
              "beta",
              "preview",
              "coming_soon"
            ],
            "ui:description": "Lifecycle status of the agent"
          },
          "enabled": {
            "type": "boolean",
            "ui:description": "Whether this agent is enabled for the domain"
          }
        },
        "required": [
          "name",
          "status",
          "enabled"
        ]
      }
    }
  },
  "default": {
    "agents": {
      "web-agent": {
        "description": "Engages visitors on your website through chat & AI sections.",
        "name": "Website Agent",
        "status": "active",
        "enabled": true
      },
      "nurturing-agent": {
        "description": "Follows up by email based on conversation history.",
        "name": "Nurturing Agent",
        "status": "beta",
        "enabled": false
      },
      "crm-agent": {
        "description": "Hands off hot leads to sales with conversation context.",
        "name": "Handoff Agent",
        "status": "beta",
        "enabled": false
      },
      "contact-agent": {
        "description": "Proactive outbound to qualified visitors on intent signals.",
        "name": "Outreach Agent",
        "status": "beta",
        "enabled": false
      },
      "content-agent": {
        "description": "Optimizes content for AI search engines (Perplexity, ChatGPT).",
        "name": "GEO Agent",
        "status": "beta",
        "enabled": false
      },
      "llm-agent": {
        "description": "Surface your brand in ChatGPT via custom GPT & actions.",
        "name": "ChatGPT Agent",
        "status": "beta",
        "enabled": false
      }
    }
  }
}
